module.exports = __webpack_public_path__ + "static/img/gsjs_tu3.1e092ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gsjs_tu3.png
// module id = MI2n
// module chunks = 0